import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import "../../assets/css/modal.css";
import "./LoginDivOnly.css";
import axios from "axios";
import { baseUrl, portal, dataContext } from "../../App";
import activityLogSubmission from "../../helper/activitylog";
import { useNavigate, useSearchParams } from "react-router-dom";
import analyticEvent from "../../helper/gaEvent";
import { fetchSubscriptionUrl } from "../../services";
import { IoCall } from "react-icons/io5";

const LoginDivOnly = ({
  activeBottom,
  setShowTCModalTournament,
  setActiveBottom,
  setShowOtpModal,
  showOtpModal,
  setShowLoginModalCampaign,
  subscriptionType = "Wordly",
  placement = "center"
}) => {
  const { token, setToken, playerData, setPlayerData } =
    useContext(dataContext);
  const [mobileNumber, setMobileNumber] = useState("");
  const [showErrorOutline, setShowErrorOutline] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMobileNumberOkay, setIsMobileNumberOkay] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  let navigate = useNavigate();

  const fixedStyles = {
    phoneIcon: {
      color: "#5E3E8D",
      fontSize: "20px",
      marginRight: "10px",
      flexShrink: 0,
    }
  };
  useEffect(() => {
    analyticEvent('login', 'login-view')
    if (activeBottom === "campaign") {
      localStorage.setItem("AuthToken", "");
    }
  }, [])
  function checkMobileNumber() {
    var mobilePattern = /^(?:\+88|88)?(01[49]\d{8})$/;
    if (mobileNumber.match(mobilePattern)) {
      return true;
    } else {
      return false;
    }
  }
  function loginOperation() {
    if (checkMobileNumber()) {
      setIsLoading(true);
      axios
        .post(`${baseUrl}/api/login/`, {
          msisdn: mobileNumber.toString().slice(-10),
          portal: portal,
          qcid: sessionStorage.getItem("cid")
        })
        .then((response) => {
          // console.log(response.data.token);
          let newToken = response.data.token;
          if (response.data?.isSubscribeWordly !== undefined) {
            response.data.isSubscribe = response.data.isSubscribeWordly;
          }
          localStorage.setItem("AuthToken", newToken);
          localStorage.setItem("user_msisdn", mobileNumber.toString().slice(-10));
          setToken(newToken);
          analyticEvent('login', 'login-success')
          if (activeBottom === "campaign") {
            if( subscriptionType === "Wordly" && response.data?.isSubscribe){navigate("../");}
            else if( subscriptionType === "SpellingBee" && response.data?.isSubscribeSpellingBee){navigate("../");}
            else if( subscriptionType === "MemoryMatch" && response.data?.isSubscribeMemoryMatch){navigate("../");}
            else{
              activityLogSubmission(
                "login_submit",
                mobileNumber.toString().slice(-10)
              );
              fetchSubscriptionUrl(newToken, subscriptionType)
              .then((res) => {
                setShowOtpModal(true);
                setShowLoginModalCampaign(false);
              });
            }
          }else{
            setIsLoading(false);
          }
        });
    } else {
      console.log("error");
      setShowErrorOutline(true);
      analyticEvent('login', 'login-error')
    }
  }

  if (placement === "bottom") {
    return (
      <div className="fixedDivLoginBottom">
        <div className="bottomLoginInput">
          <span className={`inputSpan ${showErrorOutline && "errorOutline"}`}>
            <IoCall style={fixedStyles.phoneIcon} />
            +88{" "}
            <input
              type="tel"
              maxLength={11}
              onKeyUp={(e) => {
                setMobileNumber(e.target.value);
                setIsMobileNumberOkay(checkMobileNumber());
                setShowErrorOutline(false);
              }}
              onChange={(e) => {
                setMobileNumber(e.target.value);
                setIsMobileNumberOkay(checkMobileNumber());
                setShowErrorOutline(false);
              }}
              onKeyDown={(e) => e.key === "Enter" && loginOperation()}
              id="mobileNumber"
              name="mobileNumber"
              placeholder="01XXXXXXXXX"
              className="inputFieldMobile"
            />
          </span>
        </div>
        <div className="bottomLoginAction">
          <button
            type="button"
            className="btn numberSubmit bottomSubmit"
            onClick={loginOperation}
          >
            {isLoading ? (
              <Spinner animation="border" variant="light" size="sm" />
            ) : (
              "লগইন"
            )}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
className="fixedDivLogin"
      >
        <Modal.Header>
          <Modal.Title><div style={{width: "100%", display: "flex", justifyContent: "center"}}>
          <div style={{width: "75%"}}>পাজল খেলতে রেজিস্টার/লগইন করুন</div>
          </div></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{paddingBottom: "10px",width:'90%'}}>বাংলালিংক নম্বর</div>
          <span className={`inputSpan ${showErrorOutline && "errorOutline"}`}>
            +88{" "}
            <input
              type="tel"
              maxLength={11}
              onKeyUp={(e) => {
                setMobileNumber(e.target.value);
                setIsMobileNumberOkay(checkMobileNumber());
              }}
              onChange={(e) => {
                setMobileNumber(e.target.value);
                setIsMobileNumberOkay(checkMobileNumber());
              }}
              onKeyDown={(e) => e.key === "Enter" && loginOperation()}
              id="mobileNumber"
              name="mobileNumber"
              placeholder="01XXXXXXXXX"
              className="inputFieldMobile"
            />{" "}
          </span>
        </Modal.Body>
        <Modal.Footer>
        <div style={{display: "flex", justifyContent: "center", width: "100%"}}>
          <button
            type="button"
            className="btn numberSubmit"
            onClick={loginOperation}
            disabled={!isMobileNumberOkay}
            style={{
                  backgroundColor: !isMobileNumberOkay ? "#757575" : "#FB005D",
                }}
          >
            {isLoading ? (
              <Spinner animation="border" variant="light" size="sm" />
            ) : (
              "লগইন"
            )}
          </button>
          </div>
          {/* <span style={{textDecoration: "underline", cursor: "pointer", fontSize: "12px"}} onClick={() => {setShowTCModalTournament(true)}}>Terms & Conditions</span> */}
        </Modal.Footer>
      </div>
    </>
  );
};

export default LoginDivOnly;
